import { useCallback, useLayoutEffect, useState } from "react";

export const useResizeWindow = () => {
    const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

    const handleSize = useCallback(() => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }, []);

    useLayoutEffect(() => {
        handleSize();

        window.addEventListener("resize", handleSize);

        return () => window.removeEventListener("resize", handleSize);
    }, [handleSize]);

    return windowSize;
};
